import React, { useState } from 'react';
// import { BrowserRouter as Router, Route, useParams } from 'react-router-dom';
import { useParams, useNavigate } from 'react-router-dom';

import { DeviceProvider } from '../context/DeviceContext';
import DeviceLoader from '../context/DeviceLoader';
import useSession from '../hooks/useSession'; // Session ID'yi alacak hook
import DeviceList from '../components/DeviceList'; // Cihaz listesini gösterecek bileşen
import SSEListener from '../hooks/SSEListener';
// import Heartbeat from '../hooks/HeartbeatListener';
import RefreshComponent from '../hooks/RefreshComponent';


interface RouteParams {
    data?: string;
    hash?: string;
}


const MainApp = () => {

    const { data, hash } = useParams();
    const navigate = useNavigate();
    const sessionId = useSession();
    const [loaded, setLoaded] = useState(false); // Cihazlar yüklendi mi diye kontrol için flag
    if (!sessionId) {
        return <div>Loading session...</div>;
    }

    try {
        // Hata mesajları
        if (!data || !hash) {
            throw new Error('Data and hash must not be null');
        }

        // Data formatı kontrolü: unixTime1:unixTime2:documentId:clientId
        // const dataFormat = /^\d+:\d+:\d+:[0-1]:[a-zA-Z0-9]+:[a-zA-Z0-9]+:[a-zA-Z0-9]+$/;
        const dataFormat = /^\d+:\d+:\d+:[012]:[a-zA-Z0-9_-]+:[a-zA-Z0-9_-]+:[a-zA-Z0-9_-]+$/;

        if (!dataFormat.test(data)) {
            throw new Error('Data format is invalid. Expected format: version:unixTime1:unixTime2:askPin:clientId:clientCode:guardId');
        }

        // http://localhost:4000/2:1739566800:1798664400:0:1000000001:tr1000001:1000000002/3889bf25a268336c4100f9346e188b4fe5970a26517f31c6f57860878bebd358
        // Data'yı ayır
        const [urlVersionStr, unixTime1Str, unixTime2Str, askPinStr, clientDocId, clientIdCode, guardDocId] = data.split(':');
        const unixTime1 = parseInt(unixTime1Str, 10);
        const unixTime2 = parseInt(unixTime2Str, 10);
        const askPin = parseInt(askPinStr, 10);
        const currentTime = Math.floor(Date.now() / 1000); // Mevcut zamanı UNIX formatında al

        // Zaman aralığı kontrolü
        if (currentTime < unixTime1 || currentTime > unixTime2) {
            throw new Error(`Current time (${currentTime}) is not within the valid range (${unixTime1} to ${unixTime2}).`);
        }
        const docId = `${data}/${hash}`;


        // console.log(`MainApp-sessionId: ${sessionId}`);
        // console.log(`MainApp-data: ${data}`);
        // console.log(`MainApp-hash: ${hash}`);

        // <DeviceLoader sessionId={sessionId} docId={docId} /> {/* docId ve sessionId'yi DeviceLoader'a gönder */}

        return (
            <DeviceProvider> {/* DeviceProvider tüm bileşenleri sarıyor */}
                <DeviceLoader sessionId={sessionId} docId={docId} onLoaded={() => setLoaded(true)} /> {/* Cihazlar yüklendiğinde flag güncelleniyor */}
                {loaded && <SSEListener sessionId={sessionId} />} {/* SSE bağlantısını başlatan bileşen */}
                <div className="App">
                    {/* <h1>Device List</h1> */}
                    {/* <Heartbeat/> */}
                    <DeviceList /> {/* Cihazları listeleyecek */}
                    <RefreshComponent />
                </div>
            </DeviceProvider>
        );

    } catch (error: any) {
        console.error(error.message);
        // navigate('/error'); // Hata sayfasına yönlendirme
        navigate('/error', { state: { message: error.message } });
        return null;
    }

};

export default MainApp;